import { render, staticRenderFns } from "./AppInputTags.vue?vue&type=template&id=27c69c3a&scoped=true"
import script from "./AppInputTags.vue?vue&type=script&lang=js"
export * from "./AppInputTags.vue?vue&type=script&lang=js"
import style0 from "./AppInputTags.vue?vue&type=style&index=0&id=27c69c3a&prod&lang=scss&module=true"
import style1 from "./AppInputTags.vue?vue&type=style&index=1&id=27c69c3a&prod&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "27c69c3a",
  null
  
)

export default component.exports